import React from "react";
import "./ConfirmView.css";
import { Text, Grid, Button } from '@aws-amplify/ui-react';

export default function ConfirmView({ handlerCancel, handlerConfirm, type }) {
    let message = '';
    if (type === 'project') {
        message = '¿Está seguro de remover el proyecto y todas sus asignaciones?';
    }
    if (type === 'user') {
        message = '¿Está seguro de remover este usuario definitivamente?';
    } 
    if (type === 'projectFromUser') {
        message = '¿Está seguro de remover este proyecto para este usuario?';
    } 
    if (type === 'userFromProject') {
        message = '¿Está seguro de quitar la asignación de este usuario?';
    }
    
    return (
        <>
            <div className="modal-confirm">
                <div className="overlay-confirm"></div>
                <div className='modal-content-confirm'>
                    <Grid
                        templateColumns="1fr"
                        templateRows="10rem"
                    >
                        <Text color={'orange'} marginTop={'2rem'}>
                            {message}
                        </Text>
                        <Grid
                            templateColumns="3fr 1fr"
                            templateRows="1rem 1rem"
                        >
                            <Button
                                className='button-create-assing'
                                onClick={handlerCancel}
                            >Cancelar</Button>
                            <Button
                                className='button-create-assing'
                                onClick={handlerConfirm}
                            >Confirmar</Button>
                        </Grid>
                    </Grid>
                </div>
            </div>
        </>
    );
}